import { Reveal } from "./Reveal";

const Blueprint = () => (
  <section id="blueprint" data-testid="blueprint-section" aria-labelledby="blueprint-heading" className="parchment-noise relative overflow-hidden py-24 sm:py-32">
    <div className="blueprint-grid-light absolute inset-0 opacity-60" aria-hidden="true" />
    <svg className="absolute -right-24 top-10 h-96 w-96 text-royal/15" viewBox="0 0 200 200" fill="none" aria-hidden="true">
      <circle cx="100" cy="100" r="96" stroke="currentColor" strokeWidth="0.75" />
      <circle cx="100" cy="100" r="70" stroke="currentColor" strokeWidth="0.5" strokeDasharray="4 5" />
      <circle cx="100" cy="100" r="40" stroke="currentColor" strokeWidth="0.5" />
      <path d="M100 0v200M0 100h200" stroke="currentColor" strokeWidth="0.4" />
      <path d="M30 30l140 140M170 30L30 170" stroke="currentColor" strokeWidth="0.3" />
    </svg>

    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="mb-5 flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.35em] text-ember sm:text-[11px]" data-testid="blueprint-sheet-label">
          <span className="inline-block h-px w-10 bg-ember/70" />
          Sheet VHE-02 — Master Framework
        </p>
      </Reveal>
      <div className="grid gap-12 lg:grid-cols-[1fr_auto]">
        <div className="max-w-3xl">
          <Reveal delay={0.1}>
            <h2 id="blueprint-heading" className="font-serif text-3xl font-bold leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
              The Blueprint for <em className="ember-text">Generational Impact</em>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="gold-rule my-8 max-w-xs" aria-hidden="true" />
            <p className="font-serif text-lg leading-relaxed text-royal sm:text-xl lg:text-[1.35rem]" data-testid="blueprint-body-copy">
              Through innovative design, organizational strategy, behavioral-health insight, community-centered initiatives, literary and transformative media and branding, VHE develops and fosters high-impact endeavors, environments of innovation, and ventures designed for measurable impact and lasting legacy.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.3} className="hidden lg:block">
          <ul className="flex flex-col gap-4 border-l border-ember/30 pl-8 pt-2" aria-hidden="true">
            {["Ideas", "People", "Systems", "Opportunities", "Lasting Change"].map((w) => (
              <li key={w} className="font-mono text-[11px] uppercase tracking-[0.35em] text-royal/80">{w}</li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Blueprint;
